
export const FETCH_UNIVERSITY_USERS = "FETCH_UNIVERSITY_USERS";
export const EDIT_UNIVERSITY_USER_INFO = "EDIT_UNIVERSITY_USER_INFO";
export const EDIT_USER_SPECIALTY_INFO = "EDIT_USER_SPECIALTY_INFO";
export const CREATE_USER = "CREATE_USER";
